const Input = ({id, label, name, formik, disabled = false, type = 'text', placeholder = '', required = false, readOnly = false, isLtr = false, maxLength = '', min = '', max = ''}) => {
    return (
        <div className="form-group">
            <label>{label}</label>
            <input
                type={type}
                name={name}
                id={id}
                className={`form-control ${isLtr ? 'ltr-input' : ''} ${formik.errors[name] || id ? ' is-invalid' : ''}`}
                required={required}
                readOnly={readOnly}
                maxLength={maxLength}
                placeholder={placeholder}
                {...formik.getFieldProps(name)}
                disabled={disabled}
                max={max}
                min={min}
            />
            {formik.errors[name] && formik.touched[name] && (
                <small className="text-danger">{formik.errors[name]}</small>
            )}
        </div>
    );
}

export default Input;